/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-25 20:01:06
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-25 10:11:04
 */
import * as types from '../../../mutation-types';
export default {
	[types.LOGIN_STATUS](state, status) {
		state.loginStatus = status;
	},
	[types.USER_INFO](state, obj) {
		state.vuex_userInfo = obj;
		localStorage.setItem('vuex_userInfo', JSON.stringify(obj));
	},
	[types.TENANT_ID](state, val) {
		state.vuex_tenantId = val;
		localStorage.setItem('vuex_tenantId', val);
	},
	[types.USER_ID](state, val) {
		state.vuex_userId = val;
		localStorage.setItem('vuex_userId', val);
	},
	[types.USER_TYPE_LIST](state, obj) {
		state.vuex_userTypeList = obj;
		localStorage.setItem('vuex_userTypeList', JSON.stringify(obj));
	},
	[types.DATA_VIEW_ID](state, val) {
		state.vuex_dataViewId = val;
		sessionStorage.setItem('vuex_dataViewId', val);
	},
	[types.DATA_VIEW_LIST](state, val) {
		state.vuex_dataViewList = val;
		sessionStorage.setItem('vuex_dataViewList', JSON.stringify(val));
	},

	[types.SPH_EXPO_NAME](state, val) {
		state.vuex_sphExpoName = val;
		localStorage.setItem('vuex_sphExpoName', val);
	},
	[types.INVITE_DATA](state, obj) {
		state.vuex_inviteData = obj;
		localStorage.setItem('vuex_inviteData', JSON.stringify(obj));
	},
};
